// Beta gratuita EXTENDIDA a 2027 (dueño 2026-08-02: se APARCA la estrategia de
// pago — la web oculta toda referencia a pago/precio/facturación y el banner
// pasa a decir solo "Free beta", sin fecha). Mecanismo INTACTO y reversible:
// para reactivar el pago algún día, acercar esta fecha Y la env var
// DOWNLOADABLE_BETA_UNTIL de Netlify (netlify/functions/_trial.ts) — la SPA no
// lee env en runtime, por eso la fecha está duplicada: si cambias una, cambia
// la otra. La estrategia futura pasa por gasto de tokens, no por este trial.
export const BETA_UNTIL = Date.parse('2026-12-31T23:59:59Z');

export function isBetaActive(now: number = Date.now()): boolean {
  return now < BETA_UNTIL;
}
